module.exports = __webpack_public_path__ + "static/img/218_TO8_1939_og.ae38bd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/218_TO8_1939_og.jpg
// module id = 4Td7
// module chunks = 0